import { modalService } from "../../framework";
import GuidanceRegistry from "../guidance-registry";


GuidanceRegistry.register({
    type: 'action-item-byop-upsell',
    prompt: (item) => "Want to save money while offering more benefits to your employees? For your next renewal, Ameriflex is offering Telescope Health (Care Navigation & Virtual Care) and Intellect (Mental Health Services) plans, which we can bundle with your existing plan.",
    briefDescription: "Build your own plan",
    actions: [
        {
            text: 'Yes, contact me with details',
            recommended: true,
            click: async(component, guidanceItem) => {
                await creatLeadInSalesforce(component, guidanceItem);
                await closeActionItem(guidanceItem);
                await modalService.info('Thanks for your interest! A member of our Sales team will be reaching out within 24 hours to discuss these exciting new options with you.');
            }
        },
        {
            text: 'No',
            click: async(component, guidanceItem) => {
                await closeActionItem(guidanceItem);
            }
        }
    ]
})

async function creatLeadInSalesforce(component, guidanceItem) {
    let actionItem = await romeApi.get(`actionitem/v-2/${guidanceItem.actionItemId}`)
    await romeApi.post(`employer/${guidanceItem.employerId}/order/${actionItem.orderId}/byop`);
}

async function closeActionItem(guidanceItem) {
    await romeApi.post(`actionitem/v-2/${guidanceItem.actionItemId}/complete`);
}


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-byop.js